import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './WhatWeDo.module.css';
import Button from '../../../shared/ui/button/Button';
import {
    OptimizedMotionH1,
    OptimizedMotionP,
    OptimizedMotion,
    OptimizedMotionH2,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';
import StartButton from '../shared/start-button/StartButton';
const WhatWeDo: React.FC = () => {
    const navigate = useNavigate();

    const handleRequestDemo = () => {
        navigate('/contact');
    };

    return (
        <section className={styles.whatWeDoSection}>
            {/* Background blur effects */}

            {/* Main content container */}
            <div className={styles.contentContainer}>
                <div className={styles.mainContent}>
                    <OptimizedMotionH2 className={styles.title} type="slide-down" delay={0.2}>
                        <span className={styles.titleHighlight}>What</span>{' '}
                        <span className={styles.wrenchIcon}>🌎</span> We Do
                    </OptimizedMotionH2>

                    {/* Description text */}
                    <OptimizedMotionP className={styles.description} type="slide-left" delay={0.4}>
                        SimpleeCreate is an AI-powered content-operations platform built for
                        fast-moving marketing teams that demand speed, consistency, and control. By
                        bringing together intelligent automation, collaborative tools, and
                        brand‑voice precision in one intuitive hub, we help teams plan, produce,
                        approve, and publish content across every channel—without missing a beat.
                    </OptimizedMotionP>

                    <StartButton className={styles.startBtn} />
                </div>
            </div>
        </section>
    );
};

export default WhatWeDo;
